import Model, { hasMany } from '@ember-data/model';
import type EnrichedContent from './enriched-content.ts';

export default class EnrichedContentable extends Model {
  /*************************
   **  Relationships      **
   *************************/
  @hasMany('enriched-content', {
    async: false,
    inverse: null,
    as: 'enriched-contentable',
  })
  declare enrichedContents: EnrichedContent[];
}
